<template>
  <SectionContainerPage>
    <SectionAssetList
      :shouldShowSearch="true"
      title="Equipment"
      v-model="selectedAssets"
      :toolbarActions="[
        {
          text: 'Equipment',
          icon: 'add',
          iconColor: 'success',
          emitEvent: 'onAddNewAssetClicked',
        },
        {
          text: 'Activity',
          icon: 'add',
          iconColor: 'success',
          emitEvent: 'onAddNewActivityClicked',
          isDisabledFunc: () => {
            return selectedAssets && !selectedAssets.length;
          },
        },
        {
          text: 'Filter',
          icon: 'filter_list',
          iconColor: 'accent',
          emitEvent: 'onShowFilterClicked',
        },
        {
          text: 'Export',
          icon: 'print',
          iconColor: 'accent',
          emitEvent: 'onExportClicked',
        },
      ]"
      @onAddNewAssetClicked="showDialogFormAssetAdd = true"
      @onAddNewActivityClicked="showDialogFormActivityAdd = true"
      @onShowFilterClicked="showDialogFormAssetFilter = true"
      @onClickViewEquipment="
        (val) =>
          $emit('onClickViewEquipmentFromAssetList', {
            ...val,
            breadCrumbTitle: 'Equipment',
          })
      "
      @onShouldSearch="(val) => [(currentPage = 1), onShouldSearch(val)]"
      @onClickPageChange="(val) => [(currentPage = val), fetchAssetList()]"
      @onExportClicked="onExportClicked"
      :currentPage="currentPage"
      :numberOfPages="numberOfPages"
      :assetList="assetList"
      :modelList="modelList"
      :manufacturerList="manufacturerList"
      :categoryList="categoryList"
      :activityTypeList="activityTypeList"
      :assetStatusList="assetStatusList"
      :locationList="locationList"
      :clientList="clientList"
      :userList="userList"
      :isLoading="isLoading"
    >
      <template
        v-slot:toolbarExtension
        v-if="
          (selectedAssets && selectedAssets.length) ||
          (filters &&
            ((filters.statusIds && filters.statusIds.length) ||
              (filters.activityTypeIds && filters.activityTypeIds.length) ||
              (filters.modelIds && filters.modelIds.length) ||
              (filters.categoryIds && filters.categoryIds.length) ||
              (filters.locationIds && filters.locationIds.length) ||
              (filters.ownerIds && filters.ownerIds.length) ||
              (filters.manufacturerIds && filters.manufacturerIds.length)))
        "
      >
        <v-layout column>
          <v-flex v-if="selectedAssets && selectedAssets.length">
            <span class="subheading"
              >Selected ({{ selectedAssets.length }})</span
            >
            <v-chip
              v-for="asset in selectedAssets"
              :key="asset.id"
              @input="selectedAssets.splice(selectedAssets.indexOf(asset), 1)"
              close
              :disabled="isLoading"
            >
              {{
                "" +
                asset.name +
                " - " +
                _entityPropertyValueByName({
                  entityList: modelList,
                  idKey: "id",
                  idValue: asset.modelId,
                  propertyKey: "name",
                }) +
                " - " +
                _entityPropertyValueByName({
                  entityList: locationList,
                  idKey: "id",
                  idValue: asset.locationId,
                  propertyKey: "name",
                })
              }}
            </v-chip>
            <v-btn
              color="accent"
              small
              @click="selectedAssets.splice(0, selectedAssets.length)"
              :disabled="isLoading"
            >
              clear equipment
            </v-btn>
          </v-flex>
          <v-flex
            v-if="filters && filters.statusIds && filters.statusIds.length"
          >
            <span class="subheading"
              >Status Filters ({{ filters.statusIds.length }})</span
            >
            <v-chip
              v-for="assetStatusId in filters.statusIds"
              :key="assetStatusId"
              @input="
                [
                  filters.statusIds.splice(
                    filters.statusIds.indexOf(assetStatusId),
                    1
                  ),
                  fetchAssetList(),
                ]
              "
              close
              :disabled="isLoading"
            >
              {{
                "" +
                _entityPropertyValueByName({
                  entityList: assetStatusList,
                  idKey: "id",
                  idValue: assetStatusId,
                  propertyKey: "name",
                })
              }}
            </v-chip>
            <v-btn
              color="accent"
              small
              @click="
                [
                  filters.statusIds.splice(0, filters.statusIds.length),
                  fetchAssetList(),
                ]
              "
              :disabled="isLoading"
            >
              clear statuses
            </v-btn>
          </v-flex>
          <v-flex
            v-if="
              filters &&
              filters.activityTypeIds &&
              filters.activityTypeIds.length
            "
          >
            <span class="subheading"
              >Last Activity Filters ({{
                filters.activityTypeIds.length
              }})</span
            >
            <v-chip
              v-for="activityTypeId in filters.activityTypeIds"
              :key="activityTypeId"
              @input="
                [
                  filters.activityTypeIds.splice(
                    filters.activityTypeIds.indexOf(activityTypeId),
                    1
                  ),
                  fetchAssetList(),
                ]
              "
              close
              :disabled="isLoading"
            >
              {{
                "" +
                _entityPropertyValueByName({
                  entityList: activityTypeList,
                  idKey: "id",
                  idValue: activityTypeId,
                  propertyKey: "name",
                })
              }}
            </v-chip>
            <v-btn
              color="accent"
              small
              @click="
                [
                  filters.activityTypeIds.splice(
                    0,
                    filters.activityTypeIds.length
                  ),
                  fetchAssetList(),
                ]
              "
              :disabled="isLoading"
            >
              clear activities
            </v-btn>
          </v-flex>
          <v-flex v-if="filters && filters.modelIds && filters.modelIds.length">
            <span class="subheading"
              >Model Filters ({{ filters.modelIds.length }})</span
            >
            <v-chip
              v-for="modelId in filters.modelIds"
              :key="modelId"
              @input="
                [
                  filters.modelIds.splice(filters.modelIds.indexOf(modelId), 1),
                  fetchAssetList(),
                ]
              "
              close
              :disabled="isLoading"
            >
              {{
                "" +
                _entityPropertyValueByName({
                  entityList: modelList,
                  idKey: "id",
                  idValue: modelId,
                  propertyKey: "name",
                })
              }}
            </v-chip>
            <v-btn
              color="accent"
              small
              @click="
                [
                  filters.modelIds.splice(0, filters.modelIds.length),
                  fetchAssetList(),
                ]
              "
              :disabled="isLoading"
            >
              clear models
            </v-btn>
          </v-flex>
          <v-flex
            v-if="
              filters &&
              filters.manufacturerIds &&
              filters.manufacturerIds.length
            "
          >
            <span class="subheading"
              >Manufacturer Filters ({{ filters.manufacturerIds.length }})</span
            >
            <v-chip
              v-for="manufacturerId in filters.manufacturerIds"
              :key="manufacturerId"
              @input="
                [
                  filters.manufacturerIds.splice(
                    filters.manufacturerIds.indexOf(manufacturerId),
                    1
                  ),
                  fetchAssetList(),
                ]
              "
              close
              :disabled="isLoading"
            >
              {{
                "" +
                _entityPropertyValueByName({
                  entityList: manufacturerList,
                  idKey: "id",
                  idValue: manufacturerId,
                  propertyKey: "name",
                })
              }}
            </v-chip>
            <v-btn
              color="accent"
              small
              @click="
                [
                  filters.manufacturerIds.splice(
                    0,
                    filters.manufacturerIds.length
                  ),
                  fetchAssetList(),
                ]
              "
              :disabled="isLoading"
            >
              clear manufacturers
            </v-btn>
          </v-flex>
          <v-flex
            v-if="filters && filters.categoryIds && filters.categoryIds.length"
          >
            <span class="subheading"
              >Category Filters ({{ filters.categoryIds.length }})</span
            >
            <v-chip
              v-for="categoryId in filters.categoryIds"
              :key="categoryId"
              @input="
                [
                  filters.categoryIds.splice(
                    filters.categoryIds.indexOf(categoryId),
                    1
                  ),
                  fetchAssetList(),
                ]
              "
              close
              :disabled="isLoading"
            >
              {{
                "" +
                _entityPropertyValueByName({
                  entityList: categoryList,
                  idKey: "id",
                  idValue: categoryId,
                  propertyKey: "name",
                })
              }}
            </v-chip>
            <v-btn
              color="accent"
              small
              @click="
                [
                  filters.categoryIds.splice(0, filters.categoryIds.length),
                  fetchAssetList(),
                ]
              "
              :disabled="isLoading"
            >
              clear categories
            </v-btn>
          </v-flex>
          <v-flex
            v-if="filters && filters.locationIds && filters.locationIds.length"
          >
            <span class="subheading"
              >Location Filters ({{ filters.locationIds.length }})</span
            >
            <v-chip
              v-for="locationId in filters.locationIds"
              :key="locationId"
              @input="
                [
                  filters.locationIds.splice(
                    filters.locationIds.indexOf(locationId),
                    1
                  ),
                  fetchAssetList(),
                ]
              "
              close
              :disabled="isLoading"
            >
              {{
                "" +
                _entityPropertyValueByName({
                  entityList: locationList,
                  idKey: "id",
                  idValue: locationId,
                  propertyKey: "name",
                })
              }}
            </v-chip>
            <v-btn
              color="accent"
              small
              @click="
                [
                  filters.locationIds.splice(0, filters.locationIds.length),
                  fetchAssetList(),
                ]
              "
              :disabled="isLoading"
            >
              clear locations
            </v-btn>
          </v-flex>
          <v-flex v-if="filters && filters.ownerIds && filters.ownerIds.length">
            <span class="subheading"
              >Owner Filters ({{ filters.ownerIds.length }})</span
            >
            <v-chip
              v-for="ownerId in filters.ownerIds"
              :key="ownerId"
              @input="
                [
                  filters.ownerIds.splice(filters.ownerIds.indexOf(ownerId), 1),
                  fetchAssetList(),
                ]
              "
              close
              :disabled="isLoading"
            >
              {{
                "" +
                _entityPropertyValueByName({
                  entityList: clientList,
                  idKey: "id",
                  idValue: ownerId,
                  propertyKey: "name",
                })
              }}
            </v-chip>
            <v-btn
              color="accent"
              small
              @click="
                [
                  filters.ownerIds.splice(0, filters.ownerIds.length),
                  fetchAssetList(),
                ]
              "
              :disabled="isLoading"
            >
              clear owners
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </SectionAssetList>
    <DialogFormAssetAdd
      :showDialog="showDialogFormAssetAdd"
      @onCancelClicked="showDialogFormAssetAdd = false"
      @onSubmitClicked="(val) => [onDialogFormAssetAddSubmit(val)]"
      :modelList="modelList"
      :manufacturerList="manufacturerList"
      :categoryList="categoryList"
      :locationList="locationList"
      :clientList="clientList"
      :isLoading="isLoading"
    />
    <DialogFormActivityAdd
      :showDialog="showDialogFormActivityAdd"
      @onCancelClicked="showDialogFormActivityAdd = false"
      @onSubmitClicked="(val) => [onDialogFormActivityAddSubmit(val)]"
      :selectedAssets="selectedAssets"
      :modelList="modelList"
      :locationList="locationList"
      :clientList="clientList"
      :userList="userList"
      :activityTypeList="activityTypeList"
      :assetStatusList="assetStatusList"
      :isLoading="isLoading"
    />
    <DialogFormAssetFilter
      :showDialog="showDialogFormAssetFilter"
      :filtersToEdit="filters"
      @onCancelClicked="showDialogFormAssetFilter = false"
      @onSubmitClicked="
        (val) => [
          onDialogFormAssetFilterSubmit(val),
          (showDialogFormAssetFilter = false),
        ]
      "
      :modelList="modelList"
      :manufacturerList="manufacturerList"
      :categoryList="categoryList"
      :activityTypeList="activityTypeList"
      :locationList="locationList"
      :clientList="clientList"
      :assetStatusList="assetStatusList"
      :isLoading="isLoading"
    />
    <DialogFormConfirmation
      :showDialog="confirmationDialogShow"
      :title="confirmationDialogTitle"
      :message="confirmationDialogMessage"
      :submitButtonText="confirmationDialogSubmitButtonText"
      :submitButtonIcon="confirmationDialogSubmitButtonIcon"
      :submitButtonColor="confirmationDialogSubmitButtonColor"
      :cancelButtonText="confirmationDialogCancelButtonText"
      :showCancelButton="confirmationDialogShowCancelButton"
      @onSubmitClicked="onConfirmationDialogSubmitClicked"
      @onCancelClicked="onConfirmationDialogCancelClicked"
      :isLoading="isLoading"
    />
  </SectionContainerPage>
</template>

<script>
import mixinAssetApi from '../../../common/mixins/mixinAssetApi'
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'
import mixinConfirmationDialog from '../../../common/mixins/mixinConfirmationDialog'

import SectionContainerPage from '../../../common/components/layouts/SectionContainerPage'
import SectionAssetList from './sections/SectionAssetList'
import DialogFormAssetAdd from '../dialogs/DialogFormAssetAdd'
import DialogFormActivityAdd from '../dialogs/DialogFormActivityAdd'
import DialogFormAssetFilter from '../dialogs/DialogFormAssetFilter'
import DialogFormConfirmation from '../dialogs/DialogFormConfirmation'

export default {
  components: {
    SectionContainerPage,
    SectionAssetList,
    DialogFormAssetAdd,
    DialogFormActivityAdd,
    DialogFormAssetFilter,
    DialogFormConfirmation,
  },
  mixins: [mixinAssetApi, mixinAssetHelper, mixinConfirmationDialog],
  props: {},
  data: () => ({
    showDialogFormAssetAdd: false,
    showDialogFormActivityAdd: false,
    showDialogFormAssetFilter: false,
    selectedAssets: [],
    currentPage: 1,
    pageSize: 15,
    totalPageItems: 0,
    searchText: null,
    filters: {
      statusIds: null,
      activityTypeIds: null,
      modelIds: null,
      categoryIds: null,
      locationIds: null,
      ownerIds: null,
      manufacturerIds: null,
    },
    assetList: [],
    modelList: [],
    manufacturerList: [],
    categoryList: [],
    activityTypeList: [],
    assetStatusList: [],
    locationList: [],
    clientList: [],
    userList: [],
    isLoadingCount: 0,
  }),
  activated() {
    this.fetchAssetList()
    this.fetchLists()
  },
  computed: {
    isLoading() {
      return this.isLoadingCount > 0
    },
    numberOfPages() {
      return this.totalPageItems > this.pageSize
        ? Math.ceil(this.totalPageItems / this.pageSize)
        : 1
    },
  },
  watch: {
    isLoading() {
      this.$emit('isLoadingChange', this.isLoading)
    },
  },
  methods: {
    onShouldSearch(searchText) {
      this.searchText = searchText
      this.fetchAssetList()
    },
    onDialogFormAssetFilterSubmit(data) {
      this.currentPage = 1
      this.filters = data
      this.fetchAssetList()
    },
    onDialogFormAssetAddSubmit(data) {
      let addAssetActionAfterCreate = data.addAssetActionAfterCreate
      this.isLoadingCount++
      this._insertAsset({
        names: data.assetNames,
        locationId: data.locationId,
        clientId: data.clientId,
        modelId: data.modelId,
        comments: data.comments,
        successCb: (data) => {
          this.isLoadingCount--
          this.showDialogFormAssetAdd = false
          this.fetchAssetList()
          this.$emit('notify', { message: 'Equipment successfully created!' })
          if (addAssetActionAfterCreate) {
            this.selectedAssets = [data]
            this.showDialogFormActivityAdd = true
          }
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onDialogFormActivityAddSubmit(data) {
      this.isLoadingCount++
      this._insertActivity({
        assetIds: data.assetIds,
        statusId: data.statusId,
        typeId: data.typeId,
        dateTimeEpochPerformedOn: data.dateTimeEpochPerformedOn,
        userIdPerformedBy: data.userIdPerformedBy,
        locationId: data.locationId,
        files: data.files,
        comments: data.comments,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormActivityAdd = false
          this.selectedAssets.splice(0, this.selectedAssets.length)
          this.fetchAssetList()
          this.$emit('notify', { message: 'Activity successfully created!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchAssetList() {
      this.isLoadingCount++
      this._fetchAssetList({
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        searchText: this.searchText,
        statusIds: this.filters.statusIds,
        activityTypeIds: this.filters.activityTypeIds,
        modelIds: this.filters.modelIds,
        categoryIds: this.filters.categoryIds,
        locationIds: this.filters.locationIds,
        ownerIds: this.filters.ownerIds,
        manufacturerIds: this.filters.manufacturerIds,
        successCb: (data) => {
          this.isLoadingCount--
          this.assetList = data.assetList
          this.totalPageItems = data.totalCount
          this.pageSize = data.pageSize
          this.currentPage = data.pageNumber
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onExportClicked() {
      this.isLoadingCount++
      this._fetchAssetListExcel({
        searchText: this.searchText,
        statusIds: this.filters.statusIds,
        activityTypeIds: this.filters.activityTypeIds,
        modelIds: this.filters.modelIds,
        categoryIds: this.filters.categoryIds,
        locationIds: this.filters.locationIds,
        ownerIds: this.filters.ownerIds,
        manufacturerIds: this.filters.manufacturerIds,
        successCb: (blob) => {
          const fileURL = window.URL.createObjectURL(blob)
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            `Equipment List ${this._formatJavascriptDate({ date: new Date() })}`
          )
          document.body.appendChild(fileLink)
          fileLink.click()
          this.isLoadingCount--
          this.$emit('notify', { message: 'Export successful!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchLists() {
      this.isLoadingCount++
      this._fetch({
        types: [
          'Status',
          'Model',
          'Manufacturer',
          'Category',
          'ActivityType',
          'Location',
          'Client',
          'User',
        ],
        successCb: (data) => {
          this.isLoadingCount--
          this.modelList = data.models
          this.manufacturerList = data.manufacturers
          this.categoryList = data.categories
          this.activityTypeList = data.activityTypes
          this.assetStatusList = data.statuses
          this.locationList = data.locations
          this.clientList = data.clients
          this.userList = data.users
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.assetStatusList = []
          this.modelList = []
          this.manufacturerList = []
          this.categoryList = []
          this.activityTypeList = []
          this.locationList = []
          this.clientList = []
          this.userList = []
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
  },
}
</script>
